@if ({
  request: pointOfServicesRequest$ | async,
  }; as content) {
  @if (!content.request?.isPristine) {
    <div class="simple-card m-t-20">
      @if (!content.request?.isLoading) {
        @if (!content.request?.hasError) {
          @if (content.request?.pointOfServices?.length) {
            <div class="view-address">
              <div class="address-list-container">
                @if (content.request?.infoMessage) {
                  <div class="address-list-info-message">
                    <alert [alert]="infoMessage"></alert>
                  </div>
                }
                <ul class="address-list" #listContainer>
                  @if (!content.request?.noPOS) {
                    @for (pos of content.request?.pointOfServices; track pos) {
                      <li
                        [class.active]="pos.name === selectedPosCode"
                        [attr.data-code]="pos.name"
                        role="button"
                        >
                        <button (click)="selectAddress(pos.name!)">
                          <div class="line-1" title="{{ pos.displayName }}">
                            <span class="name">
                              <span class="material-symbols-outlined d-flex m-r-4"> location_on </span>
                              <div class="description">
                                {{ pos.displayName }}
                              </div>
                            </span>
                            <span class="distance">{{ pos.formattedDistance }}</span>
                          </div>
                          @if (isOutsideRadius(pos)) {
                            <div class="line-2">
                              <span class="name d-flex align-items-center">
                                <span class="material-symbols-outlined m-r-4"> info </span>
                                <small class="info">
                                  {{ 'storeFinder.repResponsibleForArea' | cxTranslate }}
                                </small>
                              </span>
                            </div>
                          }
                          <div>
                            <address-card
                              [card]="{ address: pos.address!, card: {} }"
                              containerClass=""
                              [showAddressTypeIcon]="false"
                            ></address-card>
                          </div>
                          @if (pos.type?.toUpperCase() !== 'WAREHOUSE' && pos.type?.toUpperCase() !== 'SERVICE_CENTER') {
                            <div class="tags">
                              <span class="tag tag-{{ pos.type }}">{{ fomattedLabelType(pos.type!) }}</span>
                            </div>
                          }
                          @if (pos.products?.length) {
                            <div class="tags">
                              @for (product of pos.products; track product) {
                                <span class="tag">{{ fomattedLabelType(product) }}</span>
                              }
                            </div>
                          }
                        </button>
                      </li>
                    }
                  } @else {
                    <li class="text-center ff-bold">{{ 'storeFinder.noContent' | cxTranslate }}</li>
                  }
                </ul>
              </div>
              <div class="container-map">
                <google-map #mapElement [center]="center" [zoom]="zoom" [width]="'100%'">
                  @for (pos of content.request?.pointOfServices; track pos) {
                    <div #cardInfo class="card-info d-none">
                      <p class="text-primary">{{ pos.displayName }}</p>
                    </div>
                    <map-marker
                      #marker="mapMarker"
                      [position]="{ lat: pos.geoPoint?.latitude!, lng: pos.geoPoint?.longitude! }"
                      (mapClick)="selectAddress(pos.name!, marker, cardInfo)"
                      [icon]="{
                        url: getPin(pos),
                      }"
                      />
                      @if (content.request?.noPOS) {
                        <map-circle [center]="center" [radius]="getCircleRadius()" [options]="circleRadius"></map-circle>
                      }
                    }
                    <!-- Do not delete this map-info-window, it could be used to add more information at pin -->
                    <!-- <map-info-window> </map-info-window> -->
                  </google-map>
                </div>
              </div>
            } @else {
              <p class="text-center ff-bold m-0">{{ 'common.storeFinder.noContent' | cxTranslate }}</p>
            }
          } @else {
            <alert [alert]="alertMessage"></alert>
          }
        } @else {
          <local-loader></local-loader>
        }
      </div>
    }
  }
